/* eslint-disable import/prefer-default-export */
import Loadable from 'react-loadable';

import LoadingPage from '../main/pages/LoadingPage';

export const LoadablePingPage = Loadable({
  loader: () => import(/* webpackChunkName: "health" */ './pages/PingPage'),
  loading: LoadingPage,
});
